module.exports = __webpack_public_path__ + "static/media/WIGO.256f212e.svg";